import React from 'react';

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Zola',
  url: 'https://www.zola.com/',
  logo: 'https://d1tntvpcrzvon2.cloudfront.net/vnassets/static/media/zola-logo.e36c4941.svg', // TODO, need to replace this with a cloudfront images
  sameAs: [
    'https://www.facebook.com/zola',
    'https://pinterest.com/zola',
    'https://twitter.com/zola',
    'https://instagram.com/zola',
  ],
};

const renderOrganizationJsonLdScript = () => (
  <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
);

export default renderOrganizationJsonLdScript;
